import { useEffect, useState } from 'react';

import { Search } from '@agendapro/emerald-icons';
import { useTranslation } from 'react-i18next';
import { SearchBarContainer } from './SearchBar.styles';
import { SearchBarProps } from './types';
import { Paragraph } from '@/UI';
import { Icon } from '../..';

const SearchBar = <T,>({
  onChange,
  placeholder,
  className,
  value,
  totalFilteredLocations,
  totalLocations,
}: SearchBarProps<T>) => {
  const { t } = useTranslation();
  const [showSearchResult, setShowSearchResult] = useState(false);

  useEffect(() => {
    setShowSearchResult(totalFilteredLocations! > 0 && value?.trim() !== '');
  }, [value, totalFilteredLocations]);

  return (
    <SearchBarContainer className={className} data-testid="searchBar">
      <div className="searchInputContainer">
        <Icon icon={<Search />} size="small" />
        <input
          value={value || ''}
          className="searchInput"
          type="text"
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
      {showSearchResult && (
        <Paragraph className="searchResultText" data-testid="searchResult">
          {t('SEARCH_RESULT', {
            totalFilteredLocations,
            totalLocations,
          })}
        </Paragraph>
      )}
    </SearchBarContainer>
  );
};

export default SearchBar;
